<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialog"
        persistent :overlay="false"
        transition="dialog-transition"
        max-width="400px"
      >
        <v-card>
          <v-card-text class="text-xs-center">
            <v-progress-circular :indeterminate="true" size="80" color="blue" v-if="problem==null && !success" class="mt-5 mb-2"></v-progress-circular>
            <h3 class="mt-5 mb-3" v-if="problem==null">{{aktualni_stav}}</h3>
            <h3 v-else class="mb-3 mt-3 red--text" v-if="problem!=null">{{problem}}</h3>
            <v-btn color="grey" v-if="problem!=null" flat @click="dialog=false">Zavřít</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogDetail"
        persistent
        max-width="1200px"
        transition="dialog-transition"
        v-if="dialogDetail"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Předávací protokol č. {{predatDetail.id}}</h2>
          </v-card-title>
          <v-card-text>
            <v-form lazy-validation ref="form">
              <v-layout row wrap>
                <v-flex xs12>
                  Klient: <router-link :to="{ path: '/klienti/'+predatDetail.osoba.id }" target="_blank">
                    {{ predatDetail.osoba.nazev_osoby }}
                  </router-link>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-4">
                <v-flex xs12 sm6 md3>
                  <datepicker v-model="predatDetail.cas_predani" label="Datum předání" :disabled="predatDetail.generovan_protokol"></datepicker>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <zpusobydoruceni v-model="predatDetail.zpusob_doruceni_id" :disabled="predatDetail.generovan_protokol"></zpusobydoruceni>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    class="mx-2"
                    label="Za klienta přebírá"
                    v-model="predatDetail.prebira"
                    :disabled="predatDetail.generovan_protokol"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <div class="table-border__radius elevation-1">
                    <v-data-table
                      :headers="headersDialog"
                      :items="predatDetail.polozky"
                      :pagination.sync="pagination"
                      :total-items="pagination.totalItems"
                      hide-actions
                    >
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ props.item.cas | formatDate }}</td>
                        <td class="text-xs-left">
                          <div v-if="props.item.identifikace!=null">
                            <router-link :to="{ path: '/klienti/' + predatDetail.osoba.id + '/sporici-programy' }" v-if="props.item.typ=='sporeni'" target="_blank">
                              {{props.item.identifikace.nazev_sporeni}}
                            </router-link>
                            <router-link :to="{ path: '/klienti/' + predatDetail.osoba.id + '/jednorazove-nakupy' }" v-if="props.item.typ=='jednorazovy_nakup'" target="_blank">
                              {{props.item.identifikace.variabilni_symbol}}
                            </router-link>
                          </div>
                        </td>
                        <td class="text-xs-left" v-if="slitek">
                          <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">
                            {{props.item.produkt.nazev}}
                          </router-link>
                        </td>
                        <td class="text-xs-left" v-if="slitek">
                          {{props.item.mnozstvi}} ks
                        </td>
                        <td>
                          <div v-if="props.item.produkt.vyzadovat_seriove_cislo">
                            <seriovecislosearch label="Zadejte sériové číslo" v-model="props.item.seriove_cislo" v-if="!predatDetail.generovan_protokol" :produkt="props.item.produkt.id" :nahradniProdukty="props.item.typ=='sporeni'" @changed="() => { predatOveritSeriovaCisla(); }" :rules="rulesRequired"></seriovecislosearch>
                            <span v-else>{{props.item.seriove_cislo}}</span>
                          </div>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <a :href="api_url + 'predani-produktu/' + predatDetail.id + '/pdf'" target="_blank"><v-btn color="green elevation-0" dark v-if="predatDetail.generovan_protokol">Vygenerovat do PDF</v-btn></a>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark v-if="ulozit && !predatDetail.generovan_protokol" @click="ulozitClick" :loading="sending">Uložit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDetail=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex grow>
                <h3>Předání produktů</h3>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" small :href="api_url_admin+'export/predavaci-protokoly/xlsx?'+export_query" target="_blank" class="ma-0" depressed>Exportovat</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-baseline class="mt-2">
              <v-flex xs12 sm5 md3 lg2>
                <osobasearch label="Osoba" v-model="filtr_osoba" class="ml-0 mr-3 pt-1" :all="true" hide-details></osobasearch>
              </v-flex>
              <v-flex shrink :class="{'xs12': $vuetify.breakpoint.xs}" class="px-3">
                <v-btn-toggle mandatory v-model="filtr_stav" class="btn-toggle__mobile">
                  <v-btn value="vse">Vše</v-btn>
                  <v-btn value="informovat">K informování</v-btn>
                  <v-btn value="predani">K předání</v-btn>
                  <v-btn value="predane">Předané</v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="filtr_stav=='predane'">
                <v-menu offset-y right v-model="menu" :close-on-content-click="false" class="d-flex grow">
                  <v-text-field
                    label="Datum předání"
                    v-model="datum"
                    slot="activator"
                    readonly
                    class="mx-2"
                    hide-details
                  ></v-text-field>
                  <v-card>
                    <v-card-text>
                      <DateRangePicker
                        :options="dateRangeOptions"
                        @input="onDateRangeChange"
                        :labels="labels"
                        @close="menu=false"
                      />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1 mt-3">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.cas | formatDate }}</td>
                  <td>
                    <router-link :to="{ path: '/klienti/'+props.item.osoba.id }" target="_blank">
                      {{ props.item.osoba.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="{ path: '/spolupracovnici/'+props.item.poradce.id }" target="_blank">
                      {{ props.item.poradce.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>
                    <div v-for="(p, n) in props.item.produkty" :key="'predani-'+props.item.id+'-produkt-'+n">
                      <router-link :to="{ path: '/produkty/' + p.id }" target="_blank">
                        {{p.mnozstvi}} ks {{p.nazev}}
                      </router-link>
                    </div>
                    <div v-if="props.item.darek"><strong>Obsahuje dárek</strong></div>
                  </td>
                  <td>
                    <span v-if="props.item.zpusob_doruceni != null">{{props.item.zpusob_doruceni.nazev}}</span>
                  </td>
                  <td>
                    <span v-if="props.item.generovan_protokol">Předáno {{ props.item.datum_predani | formatSimpleDate }}</span>
                    <span v-else-if="props.item.informovan">Čeká na předání</span>
                    <span v-else>K informování</span>
                  </td>
                  <td class="text-xs-right">
                    <v-btn color="green" @click="informovatKlienta(props.item)" dark class="elevation-0" v-if="!props.item.informovan">
                      <v-icon class="mr-2">email</v-icon> Informovat klienta
                    </v-btn>
                    <v-btn color="primary" @click="predat(props.item)" class="elevation-0" v-else-if="!props.item.generovan_protokol">
                      <v-icon class="mr-2">done</v-icon> Předat produkty
                    </v-btn>
                    <v-btn color="primary" @click="predat(props.item)" class="elevation-0" v-else-if="props.item.generovan_protokol">
                      <v-icon class="mr-2">remove_red_eye</v-icon> Detail
                    </v-btn>
                    <v-menu offset-y left v-if="!props.item.informovan">
                      <v-btn color="primary" dark slot="activator" fab class="elevation-0" small><v-icon>more_vert</v-icon></v-btn>
                      <v-list>
                        <v-list-tile @click="predatBezInformovaniKlienta(props.item)">
                          <v-list-tile-title>Předat bez informování</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DateRangePicker from '@/components/DateRange';
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      dialogDetail: false,
      sending: false,
      slitek: true,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Datum vzniku nároku', value: 'cas' },
        { text: 'Klient', value: 'osoba' },
        { text: 'Poradce', value: 'poradce' },
        { text: 'Produkty', value: 'produkty', sortable: false },
        { text: 'Způsob doručení', value: 'zpusob_doruceni', sortable: false },
        { text: 'Stav', value: 'id', sortable: false },
        { text: 'Akce', value: null, sortable: false, align: 'right' }
      ],
      headersDialog: [
        { text: 'Čas nároku', value: 'cas' },
        { text: 'Identifikace', value: 'identifikace' },
        { text: 'Produkt', value: 'produkt.nazev' },
        { text: 'Množství', value: 'mnozstvi' },
        { text: 'Sériové číslo', value: 'seriove_cislo' },
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 50,
        sortBy: "cas",
        totalItems: 0
      },
      itemsDialog: [
        {
          cilovy_produkt: 'Zlatý slitek 10g AH',
          seriove_cislo: ''
        }
      ],
      dialog: false,
      problem: null,
      aktualni_stav: null,
      success: false,
      predatPolozka: null,
      predatDetail: null,
      ulozit: false,
      rulesRequired: [
        (v) => {
          return v != null || "Pole je vyžadováno";
        }
      ],
      filtr_stav: "vse",
      filtr_osoba: null,
      labels: {
        start: "Začátek",
        end: "Konec"
      },
      dateRangeOptions: {
        startDate: moment().subtract("days", 7).format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        format: 'DD.MM.YYYY',
        presets: [
          {
            label: 'Dnes',
            range: [
              moment().format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Včera',
            range: [
              moment().subtract("days", 1).format('YYYY-MM-DD'),
              moment().subtract("days", 1).format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Tento týden',
            range: [
              moment().startOf("week").format('YYYY-MM-DD'),
              moment().endOf("week").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Minulý týden',
            range: [
              moment().subtract("weeks", 1).startOf("week").format('YYYY-MM-DD'),
              moment().subtract("weeks", 1).endOf("week").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Tento měsíc',
            range: [
              moment().startOf("month").format('YYYY-MM-DD'),
              moment().endOf("month").format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Minulý měsíc',
            range: [
              moment().subtract("months", 1).startOf("month").format('YYYY-MM-DD'),
              moment().subtract("months", 1).endOf("month").format('YYYY-MM-DD'),
            ],
          }
        ],
      },
      datum_od: null,
      datum_do: null,
      datum: null,
      menu: false,
      export_query: ""
    }
  },
  computed: {
    api_url () {
      return window.api.$api_url;
    },
    api_url_admin () {
      return window.api.$api_url;
    }
  },
  watch: {
  	pagination: {
  		handler: function() {
        this.load();
  		},
  		deep: true
  	},
    predatDetail: {
      handler: function() {
        this.predatOveritSeriovaCisla();
  		},
  		deep: true
    },
    filtr_stav () {
      this.load();
      this.makeExportQuery();
    },
    filtr_osoba () {
      this.load();
      this.makeExportQuery();
    },
    datum_od () {
      this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
    },
    datum_do () {
      this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
    }
  },
  mounted () {
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function(f) {
      this.counter++;
      this.loadingTable = true;
      window.API.post("predani-produktu/predani/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        filtr_osoba: this.filtr_osoba,
        filtr_stav: this.filtr_stav,
        datum_od: this.datum_od,
        datum_do: this.datum_do
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        for (var i = 0; i < body.data.length; i++)
          body.data[i].problem = null;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    informovatKlienta (v) {
      this.dialog = true;
      this.problem = null;
      this.aktualni_stav = "Probíhá informování klienta";
      this.success = false;
      window.API.post("predani-produktu/informovat", {
        id: v.id
      }).then(function(body) {
        if (body.updated) {
          this.load(() => {
            this.aktualni_stav = "Klient informován"
            this.success = true;
            setTimeout(() => {
              this.dialog = false;
            }, 1000);
          });
        }
        else {
          this.problem = "Nelze informovat klienta";
        }
      }.bind(this)).catch(function(err) {
        this.problem = "Nelze informovat klienta";
        console.log(err);
      }.bind(this));
    },
    predatBezInformovaniKlienta (v) {
      window.API.post("predani-produktu/bez-informovani", {
        id: v.id
      }).then(function(body) {
        this.load(() => {
          this.dialog = false;
          this.predat(v);
        });
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    predat (v) {
      this.predatPolozka = v;
      window.API.get("predani-produktu/" + v.id).then(function(body) {
        this.predatDetail = body;
        this.dialogDetail = true;
        this.predatOveritSeriovaCisla();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    predatOveritSeriovaCisla () {
      this.ulozit = this.predatDetail.polozky.filter((e) => {
        return e.produkt.vyzadovat_seriove_cislo && e.seriove_cislo == null;
      }).length == 0;
    },
    ulozitClick () {
      this.sending = true;
      if (this.$refs.form.validate()) {
        window.API.put("predani-produktu/"+this.predatDetail.id+"/predavaci-protokol", {
          cas: this.predatDetail.cas_predani,
          zpusob_doruceni: this.predatDetail.zpusob_doruceni_id,
          prebira: this.predatDetail.prebira,
          polozky: this.predatDetail.polozky.map((e) => {
            return {
              id: e.id,
              seriove_cislo: e.seriove_cislo,
              mnozstvi: e.mnozstvi
            };
          })
        }).then(function(body) {
          this.predatDetail.povolit_pdf = body.povolit_pdf;
          if (body.updated) {
            this.predatDetail.generovan_protokol = true;
            this.load(() => {
              this.ulozit = false;
              this.sending = false;
            });
          }
          else
            this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    onDateRangeChange (e) {
      this.datum_od = parseInt(moment(e[0]).startOf("day")._d.getTime()/1000);
      this.datum_do = parseInt(moment(e[1]).endOf("day")._d.getTime()/1000);
      this.load();
      this.makeExportQuery();
    },
    makeExportQuery () {
      this.export_query = [
        this.filtr_osoba != null ? "o=" + this.filtr_osoba : null,
        this.datum_od != null ? "ds=" + this.datum_od : null,
        this.datum_do != null ? "dt=" + this.datum_do : null,
        this.filtr_stav != null && this.filtr_stav.length > 0 ? "st=" + this.filtr_stav : null
      ].filter((e) => { return e != null }).join("&");
    }
  },
  components: {
    DateRangePicker
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Produkty/PredaniProduktu.vue